import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useMobile } from './MobileContext';
import { PhoneIncoming, Loader2, CheckCircle2, X } from 'lucide-react';

const Dialog = ({ t, isClient, guest, updateGuest, onDone, onClose }) => {
  const [name, setName] = useState(guest?.name || '');
  const [phone, setPhone] = useState(guest?.phone || '');
  const [busy, setBusy] = useState(false);
  const { API, headers } = useMobile();
  const send = async () => {
    if (!isClient && (!name.trim() || !phone.trim())) { toast.error(t('أدخل اسمك ورقم هاتفك', 'Enter your name and phone')); return; }
    setBusy(true);
    try {
      if (!isClient) await updateGuest({ name: name.trim(), phone: phone.trim() }).catch(() => {});
      const r = await axios.post(`${API}/m/callbacks`, { name: name.trim(), phone: phone.trim() }, { headers: headers() });
      onDone(r.data);
    } catch (e) { toast.error(e.response?.status === 409 ? t('لديك طلب اتصال قائم بالفعل', 'You already have a pending request') : t('تعذّر إرسال الطلب', 'Could not send request')); }
    setBusy(false);
  };
  return (
    <div className="fixed inset-0 z-[120] bg-black/60 flex items-center justify-center p-5" data-testid="m-callback-dialog">
      <div className="w-full max-w-sm rounded-3xl bg-white p-5 shadow-2xl">
        <div className="flex items-start justify-between"><div className="w-12 h-12 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center"><PhoneIncoming className="w-6 h-6" /></div><button onClick={onClose} className="p-1 text-slate-400" data-testid="m-callback-close"><X className="w-5 h-5" /></button></div>
        <p className="mt-3 text-base font-bold text-slate-900">{t('اطلب اتصالاً مجانياً', 'Request a free call')}</p>
        <p className="mt-1 text-sm text-slate-600 leading-relaxed">{t('سيتصل بك الموظف المختص على رقم هاتفك في أقرب وقت.', 'Our specialist will call you back on your phone shortly.')}</p>
        {!isClient && <div className="mt-3 space-y-2">
          <input value={name} onChange={e => setName(e.target.value)} placeholder={t('اسمك', 'Your name')} className="w-full h-11 rounded-xl border border-slate-200 px-3 text-base" data-testid="m-callback-name" />
          <input value={phone} onChange={e => setPhone(e.target.value)} placeholder={t('رقم هاتفك', 'Your phone')} inputMode="tel" dir="ltr" className="w-full h-11 rounded-xl border border-slate-200 px-3 text-base" data-testid="m-callback-phone" />
        </div>}
        <div className="flex gap-2 mt-4">
          <button onClick={send} disabled={busy} className="flex-1 h-11 rounded-xl bg-emerald-600 text-white text-sm font-bold flex items-center justify-center gap-2" data-testid="m-callback-send">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <PhoneIncoming className="w-4 h-4" />}{t('اتصلوا بي', 'Call me')}</button>
          <button onClick={onClose} className="flex-1 h-11 rounded-xl bg-slate-100 text-slate-700 text-sm font-bold" data-testid="m-callback-cancel">{t('إلغاء', 'Cancel')}</button>
        </div>
      </div>
    </div>
  );
};

export const CallbackTile = () => {
  const { API, headers, t, isClient, guest, updateGuest, guestId, user } = useMobile();
  const [open, setOpen] = useState(false);
  const [pending, setPending] = useState(null);
  useEffect(() => {
    if (!guestId && !user) return;
    const load = () => axios.get(`${API}/m/callbacks/pending`, { headers: headers() }).then(r => setPending(r.data?.id ? r.data : null)).catch(() => {});
    load(); const iv = setInterval(load, 8000); return () => clearInterval(iv);
  }, [guestId, user]);
  return (
    <>
      <button onClick={() => setOpen(true)} disabled={!!pending} className="relative rounded-2xl border p-3 flex flex-col items-center gap-1.5 text-center bg-emerald-600 border-emerald-600 text-white disabled:opacity-80" data-testid="m-callback-start">
        <span className="absolute -top-2 start-2 text-[9px] font-black bg-[#D4AF37] text-[#0F172A] px-2 py-0.5 rounded-full">{t('مجاني', 'FREE')}</span>
        {pending ? <CheckCircle2 className="w-5 h-5" /> : <PhoneIncoming className="w-5 h-5" />}
        <p className="text-xs font-bold leading-tight">{pending ? t('سنتصل بك قريباً', 'We will call you') : t('اطلب اتصالاً', 'Request a call')}</p>
        <p className="text-[10px] text-white/80" dir="ltr">{pending ? pending.phone : t('نتصل بك نحن', 'we call you back')}</p>
      </button>
      {open && <Dialog t={t} isClient={isClient} guest={guest} updateGuest={updateGuest} onClose={() => setOpen(false)} onDone={(cb) => { setPending(cb); setOpen(false); toast.success(t('تم إرسال طلبك — سنتصل بك قريباً', 'Request sent — we will call you shortly')); }} />}
    </>
  );
};
